var map = {
	"./3QuirkyNostalgicSocialMediaGames.webp": "BAx9",
	"./5NarrativePixelArtGamesDemos.webp": "4a2c",
	"./5StoryRichIndieGamesCuteFroggyProtagonists.webp": "Tqd9",
	"./7BeautifulIndieGames.webp": "/DRN",
	"./7eyecatchingindiegamesPYG.webp": "E/uE",
	"./9HeartwarmingGames.webp": "s5P0",
	"./AngelaHe.webp": "uvhZ",
	"./AviaryAttorney.webp": "KKcs",
	"./CardOfDarkness.webp": "qhee",
	"./Carto.webp": "paZM",
	"./Chicory.webp": "muJZ",
	"./CoffeeTalk.webp": "A8yU",
	"./DarksideDetective.webp": "wJ6M",
	"./DetectiveGui.webp": "kid+",
	"./DifficultyDifficultGames.webp": "7gH0",
	"./DontOpenYourEyes.webp": "QXs/",
	"./Eliza.webp": "LAaY",
	"./EmilyIsAway.webp": "/F2l",
	"./EverForward.webp": "jg6t",
	"./Firewatch.webp": "1Z8q",
	"./ForTheKing.webp": "Ejcr",
	"./ForThePeople.webp": "GLxA",
	"./Forager.webp": "BscX",
	"./Frogsong.webp": "doqG",
	"./IndieArenaBooth.webp": "Z+02",
	"./Lamentum.webp": "+os9",
	"./LucasPope.webp": "BXLd",
	"./MinuteOfIslands.png": "RkOE",
	"./MinuteOfIslands.webp": "nZB4",
	"./Moonlighter.webp": "RMJI",
	"./Nanopesos.webp": "T7u0",
	"./NightInTheWoods.webp": "qwut",
	"./OldMansJourney.webp": "WYLj",
	"./RiskOfRain.webp": "E14s",
	"./Rosewater.webp": "2h+Z",
	"./SortTheCourt.webp": "9P+K",
	"./Syberia.webp": "lV0p",
	"./Symphonia.webp": "1O08",
	"./TakeshiAndHiroshi.webp": "q5a7",
	"./TangleTower.webp": "ilbr",
	"./TownOfLight.webp": "2AcX",
	"./UnboundWorldsApart.webp": "gY0t",
	"./Underdown.webp": "PBRj",
	"./Venice2089.webp": "BDxx",
	"./Verne.webp": "oYxI",
	"./WelcomeToElk.webp": "boA9",
	"./WhenThePastWasAround.webp": "G9nR",
	"./WhenThePastWasAroundFull.webp": "W0OY",
	"./WindingWorlds.webp": "Kmox",
	"./cateau.webp": "+oGp",
	"./nightofrabbit.webp": "5u7n",
	"./npckc.webp": "5qPm",
	"./tacoma.webp": "tI+a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0FYN";